import { useEffect, useRef } from "react";
import CSS from "./styles.module.css";

const Button = ({
	children,
	variant,
	className,
	id,
	leftIcon,
	rightIcon,
	icon,
	onClick,
	onMouseEnter,
	onMouseLeave,
	disabled,
	contentEditable,
}) => {
	const button = useRef(null);

	useEffect(() => {
		if (disabled) {
			button.current.disabled = true;
		} else {
			button.current.disabled = false;
		}
	}, [disabled]);

	return (
		<button
			className={`${variant ? CSS[variant] : CSS.Button} ${className} ${
				disabled ? CSS.disabled : ""
			}`}
			id={id}
			onClick={onClick}
			ref={button}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
			contentEditable={contentEditable}
		>
			{leftIcon && (
				<span className={`material-symbols-rounded ${CSS.leftIcon}`}>
					{leftIcon}
				</span>
			)}
			{icon && icon}
			{children}
			{rightIcon && (
				<span className={`material-symbols-rounded ${CSS.rightIcon}`}>
					{rightIcon}
				</span>
			)}
		</button>
	);
};

export default Button;
